/**
 * Public quiz UI resources (customize tập trung tại đây).
 *
 * - QUIZ_TYPE_UI: icon/màu cho từng quiz_type.
 * - SPOTLIGHT_SUBJECT / SPOTLIGHT_LIMIT: nguồn dữ liệu spotlight.
 * - PLACEHOLDER_THUMB: ảnh placeholder cho card/list detail.
 */
export const QUIZ_TYPE_UI = {
  official: {
    icon: 'verified',
    tone: 'text-emerald-700 bg-emerald-100',
    label: 'Official',
  },
  community: {
    icon: 'star',
    tone: 'text-amber-700 bg-amber-100',
    label: 'Community',
  },
  personal: {
    icon: 'lock',
    tone: 'text-slate-700 bg-slate-200',
    label: 'Personal',
  },
};

export const SPOTLIGHT_SUBJECT = '';
export const SPOTLIGHT_LIMIT = 12;

export const PLACEHOLDER_THUMB = 'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=900&q=80';

export function getQuizTypeUi(quizType) {
  const key = String(quizType || '').toLowerCase();
  return QUIZ_TYPE_UI[key] || QUIZ_TYPE_UI.personal;
}
